// src/pages/auth/Login.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
	  e.preventDefault();
	  setError('');
	  setLoading(true);

	  const result = await login(email, password);
	  if (result.success) {
		navigate('/');
	  } else {
		// Si el error es por email no verificado
		if (result.error?.needsVerification) {
		  setError('⚠️ Por favor verifica tu email antes de iniciar sesión. Revisa tu bandeja de entrada.');
		} else {
		  setError(result.error || 'Error al iniciar sesión');
		}
	  }
	  setLoading(false);
	};

		
  return (
    <div className="auth-container">
      <div className="auth-card">
		 <img src="/logo-kreamun.png" alt="KREAMUN" className="auth-logo" />
        <h2>Iniciar Sesión</h2>
        <p className="auth-subtitle">Accede a tus universos</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="tu@email.com"
            />
          </div>

          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary btn-block"
            disabled={loading}
          >
            {loading ? 'Iniciando...' : 'Iniciar Sesión'}
          </button>
        </form>

        <p className="auth-footer">
          ¿No tienes cuenta? <Link to="/register">Regístrate</Link> 
		</p>
		<p className="auth-footer">
		<Link to="/forgot-password">¿Olvidaste tu contraseña?</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;